import { useProfile } from "@brg/auth"
import { useEffect, useState } from "react";
import urlApi from "shared/actions/urlApi";

export const useGetFeedInfo = () => {
    const profile = useProfile();

    const [hasFeedInfo, setHasFeedInfo] = useState(false);

    const fetchFeedInfo = async (id: string) => {
        const info = await urlApi()?.hasSubscribesOrSubscriptions(id)

        setHasFeedInfo(info)
    }
    useEffect(() => {
        if (profile) {
            fetchFeedInfo(profile.accountId)
        }
    } , [profile])

    return hasFeedInfo
}import { useProfile } from "@brg/auth"
import { useEffect, useState } from "react";
import urlApi from "shared/actions/urlApi";

export const useGetFeedInfo = () => {
    const profile = useProfile();

    const [hasFeedInfo, setHasFeedInfo] = useState(false);

    const fetchFeedInfo = async (id: string) => {
        const info = await urlApi()?.hasSubscribesOrSubscriptions(id)

        setHasFeedInfo(info)
    }
    useEffect(() => {
        if (profile) {
            fetchFeedInfo(profile.accountId)
        }
    } , [profile])

    return hasFeedInfo
}